<template slot-scope="scope">
  <!-- 代开发票 弹窗组件 -->
      <dialogModel
        title="开具发票"
        :visible="dialogVisible"
        @handleClose="handleClose"
        @handleOk="handleUnderstand"
      >
        <div class="main-body">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <div class="single-choice">
              <p class="title"><span style="color: red">*</span>发票性质：</p>
              <div
                class="Select-choice firm-clickable"
                v-for="(item, index) in listArr"
                :key="index"
                @click="ruleForm.listArrSelect = item.id"
              >
                <div
                  :class="
                    item.id == ruleForm.listArrSelect
                      ? 'Select-style'
                      : 'notSelect-style'
                  "
                ></div>
                <p>{{ item.name }}</p>
              </div>
            </div>
            <el-form-item prop="value">
              <div class="pull-down">
                <p class="title">
                  <span style="color: red">*</span>发票信息：
                </p>
                <div class="cen-div">
                  <el-select
                    v-model="ruleForm.value"
                    placeholder="请选择"
                    @change="handleHeadChange"
                  >
                    <el-option
                      v-for="item in headList"
                      :key="item.id"
                      :label="item.headName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>
            <div class="single-choice" style="margin-top:30px">
              <p class="title">
                <span style="color: red">*</span>默认发票类型：
              </p>
              <div
                class="Select-choice firm-clickable"
                v-for="(item, index) in listArr1"
                :key="index"
                @click="ruleForm.listArrSelect1 = item.id"
              >
                <div
                  :class="
                    item.id == ruleForm.listArrSelect1
                      ? 'Select-style'
                      : 'notSelect-style'
                  "
                ></div>
                <p>{{ item.name }}</p>
              </div>
            </div>
            <div class="pull-down" v-if="ruleForm.listArrSelect == 0">
              <el-form-item prop="value1">
                <div style="display: flex">
                  <p class="title">
                    <span style="color: red">*</span>选择邮箱：
                  </p>
                  <div class="cen-div">
                    <el-select v-model="ruleForm.value1" placeholder="请选择">
                      <el-option
                        v-for="item in mailList"
                        :key="item.id"
                        :label="item.mail"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="pull-down" v-else>
              <el-form-item prop="value2">
                <div style="display: flex">
                  <p class="title">
                    <span style="color: red">*</span>选择地址：
                  </p>
                  <div class="cen-div">
                    <el-select v-model="ruleForm.value2" placeholder="请选择">
                      <el-option
                        v-for="item in addressList"
                        :key="item.id"
                        :label="item.address"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </dialogModel>
</template>

<script>
// 引入接口
import {} from "../../../../../../assets/api/CenterInvoice";
// 封装的表单验证
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";
export default {
  props: {
    dialogVisible: {},
    select: {},
    num: {},

    headList: {}, // 抬头选项
    addressList: {}, // 地址选项
    mailList: {}, //邮箱选项
    acquiesce: {}, // 默认
  },
  components: {},
  data() {
    return {
      listArr: [
        { name: "电子发票", id: "0" },
        { name: "纸质发票", id: "1" },
      ], // 发票性质：电子/纸质
      listArr1: [
        { name: "增值税普通发票", id: "0" },
        { name: "增值税专用发票", id: "1" },
      ], // 发票类型：普票/专票
      options: [], // 搜索下拉框数据
      ruleForm: {
        listArrSelect: "0", // 选中发票性质 0电子1纸质
        listArrSelect1: "0", // 选中发票类型 0普1专
        value: "", // 发票信息
        value1: "", // 选择邮箱
        value2: "", // 选择地址
      },
      rules: {
        value: vxRule(true, "", ["blur", "change"], "请选择发票信息"),
        value1: vxRule(true, "", ["blur", "change"], "请选择邮箱"),
        value2: vxRule(true, "", ["blur", "change"], "请选择地址"),
      }, // 表单验证
    };
  },
  watch: {
    // 监听
    acquiesce: {
      handler(newss, old) {
        console.log(newss);
        if (newss.head != null) {
          this.ruleForm.value = newss.head.id;
          this.syncInvoiceTypeByHeadId(newss.head.id, newss.head);
        }
        if (newss.mail != null) {
          this.ruleForm.value1 = newss.mail.id;
        }
        if (newss.address != null) {
          this.ruleForm.value2 = newss.address.id;
        }
      },
      immediate: false,
    },
     dialogVisible: {
      handler(newSs, old) {
        if (newSs == true) {
          this.$nextTick(() => {
            this.syncInvoiceTypeByHeadId(this.ruleForm.value);
          });
        } else {
          this.$refs.ruleForm.clearValidate();
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    console.log(this.listarr);
  },
  methods: {
    // 根据选中抬头同步默认发票类型
    syncInvoiceTypeByHeadId(headId, headObj) {
      let invoiceType = null;
      if (headObj && headObj.invoiceType !== undefined && headObj.invoiceType !== null) {
        invoiceType = headObj.invoiceType;
      } else if (headId !== undefined && headId !== null && headId !== "") {
        const head = (this.headList || []).find((item) => item.id == headId);
        if (head && head.invoiceType !== undefined && head.invoiceType !== null) {
          invoiceType = head.invoiceType;
        }
      }
      if (invoiceType !== null) {
        this.ruleForm.listArrSelect1 = String(invoiceType);
      }
    },
    handleHeadChange(headId) {
      this.syncInvoiceTypeByHeadId(headId);
    },
    // 取消关闭弹窗
    handleClose() {
      this.$emit("handleCloseDele", this.dialogVisible);
      //   this.dialogVisible = false;
    },
    // 确认
    handleUnderstand(unlockConfirm, lockConfirm) {
      const unlock =
        typeof unlockConfirm === "function" ? unlockConfirm : null;
      const lock = typeof lockConfirm === "function" ? lockConfirm : null;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          lock && lock();
          this.$emit("handleUnderstand", this.ruleForm, unlock);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
/deep/.el-form-item__error {
  margin-left: 110px;
  padding-top: 2px;
  line-height: 1.2;
}

/deep/.el-textarea .el-input__count {
  bottom: -30px !important;
}
/deep/.el-form-item {
  margin-bottom: 10px;
}
/deep/.el-date-editor {
  position: relative !important;
}

.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}

.Select-choice {
  margin-left: 5px;
  margin-right: 30px;
  display: flex;
  .notSelect-style {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-image: url("../../../../../../assets/imgs/weigouxuan@3x.svg");
    background-size: 100% 100%;
    cursor: pointer;
  }
  .Select-style {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-image: url("../../../../../../assets/imgs/gouxuan@3x.svg");
    background-size: 100% 100%;
    cursor: pointer;
  }
  p {
    line-height: 18px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    margin-left: 10px;
  }
}
.pull-down {
  min-width: 430px;
  min-height: 35px;
  margin-right: auto;
  margin-bottom: 4px;
  display: flex;
  .title {
    width: 110px;
    line-height: 35px;
    text-align: right;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    flex-shrink: 0;
  }
  .cen-div {
    width: 350px;
    min-height: 35px;
    line-height: 35px;
    /deep/.el-input__inner {
      height: 35px !important;
      font-size: 14px;
      border: 1px solid #409eff ;
    }
  }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
</style>
